interface CreditCardProviderLogoProps {
  provider: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

interface ProviderCfg {
  bg: string;
  text: string;
  label: string;
  fullName: string;
  logo?: string;
}

const PROVIDER_CONFIG: Record<string, ProviderCfg> = {
  max: {
    bg: "bg-white",
    text: "text-[#1b1464]",
    label: "M",
    fullName: "Max",
    logo: "/logos/max.png",
  },
  "visa cal": {
    bg: "bg-[#2962FF]",
    text: "text-white",
    label: "Cal",
    fullName: "Visa Cal",
    logo: "/logos/cal.png",
  },
  visacal: {
    bg: "bg-[#2962FF]",
    text: "text-white",
    label: "Cal",
    fullName: "Visa Cal",
    logo: "/logos/cal.png",
  },
  isracard: {
    bg: "from-[#00875a] to-[#006644]",
    text: "text-white",
    label: "IC",
    fullName: "Isracard",
  },
};

function resolveProvider(paymentType: string): string | null {
  const match = paymentType.match(/\((.+)\)/);
  if (!match) return null;
  return match[1].toLowerCase().trim();
}

const SIZES = {
  sm: { dim: "w-4 h-4", font: "text-[7px]", rounded: "rounded-full", imgPad: "p-0" },
  md: { dim: "w-5 h-5", font: "text-[9px]", rounded: "rounded-full", imgPad: "p-0" },
  lg: { dim: "w-12 h-12", font: "text-lg", rounded: "rounded-xl", imgPad: "p-1" },
};

export function CreditCardProviderLogo({ provider, size = "sm", className = "" }: CreditCardProviderLogoProps) {
  const key = provider.toLowerCase().trim();
  const config = PROVIDER_CONFIG[key];
  if (!config) return null;

  const s = SIZES[size];

  if (config.logo) {
    return (
      <span
        className={`inline-flex items-center justify-center ${s.dim} ${s.rounded} shrink-0 overflow-hidden ${className}`}
        title={config.fullName}
      >
        <img src={config.logo} alt={config.fullName} className="w-full h-full object-contain" />
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center justify-center bg-gradient-to-br ${config.bg} ${config.text} ${s.dim} ${s.font} ${s.rounded} font-bold leading-none shrink-0 ${className}`}
      title={config.fullName}
    >
      {config.label}
    </span>
  );
}

export function CreditCardProviderBadge({ paymentType, cardNumber }: { paymentType?: string | null; cardNumber?: string | null }) {
  if (!paymentType || !cardNumber) return null;

  const providerName = resolveProvider(paymentType);
  if (!providerName) return null;

  return (
    <span className="inline-flex items-center gap-1 text-xs text-muted-foreground/70">
      <CreditCardProviderLogo provider={providerName} size="sm" />
      <span>•••• {cardNumber}</span>
    </span>
  );
}
